import { Outlet } from 'react-router-dom';

import { interruptWith } from '~/common/utils/error.util.tsx';
import useAuth from '~/features/auth/hooks/useAuth.ts';

import type { AdminRole } from '~/features/admin/types/admin.type';

interface RoleGuardProps {
  allowedRoles: AdminRole[];
}

function RoleGuard({ allowedRoles }: RoleGuardProps) {
  const {
    state: { authUser },
  } = useAuth();

  if (!authUser) return null;

  if (!allowedRoles.includes(authUser.role)) {
    return interruptWith(404);
  }

  return <Outlet />;
}

export default RoleGuard;
